export default __webpack_public_path__ + "f860ba9edcbba0ca4e14c1fb8063a626.svg";